var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 32,
    viewBox: "0 0 108 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.25697L12.9598 6.47988C13.2683 7.09701 13.7003 8.70155 12.9598 10.1827C12.2192 11.6638 10.1827 14.5026 9.25697 15.7368L0 0ZM16.6625 0H35.1764L16.6625 31.4737L11.1083 24.0681L20.3653 10.1827C21.4662 7.98088 20.6032 6.76103 19.3334 4.96609C18.4677 3.74244 17.413 2.25151 16.6625 0Z",
    fill: "url(#paint0_linear_28_261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.25697L12.9598 6.47988C13.2683 7.09701 13.7003 8.70155 12.9598 10.1827C12.2192 11.6638 10.1827 14.5026 9.25697 15.7368L0 0ZM16.6625 0H35.1764L16.6625 31.4737L11.1083 24.0681L20.3653 10.1827C21.4662 7.98088 20.6032 6.76103 19.3334 4.96609C18.4677 3.74244 17.413 2.25151 16.6625 0Z",
    fill: "url(#paint1_linear_28_261)",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.25697L12.9598 6.47988C13.2683 7.09701 13.7003 8.70155 12.9598 10.1827C12.2192 11.6638 10.1827 14.5026 9.25697 15.7368L0 0ZM16.6625 0H35.1764L16.6625 31.4737L11.1083 24.0681L20.3653 10.1827C21.4662 7.98088 20.6032 6.76103 19.3334 4.96609C18.4677 3.74244 17.413 2.25151 16.6625 0Z",
    fill: "#0B1F51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.42 8.96L55.44 23H51.16L46.18 8.96H49.82L53.3 19.56L56.8 8.96H60.42ZM65.2694 8.96V23H61.8494V8.96H65.2694ZM67.1678 15.96C67.1678 14.5733 67.4678 13.34 68.0678 12.26C68.6678 11.1667 69.5011 10.32 70.5678 9.72C71.6478 9.10667 72.8678 8.8 74.2278 8.8C75.8945 8.8 77.3211 9.24 78.5078 10.12C79.6945 11 80.4878 12.2 80.8878 13.72H77.1278C76.8478 13.1333 76.4478 12.6867 75.9278 12.38C75.4211 12.0733 74.8411 11.92 74.1878 11.92C73.1345 11.92 72.2811 12.2867 71.6278 13.02C70.9745 13.7533 70.6478 14.7333 70.6478 15.96C70.6478 17.1867 70.9745 18.1667 71.6278 18.9C72.2811 19.6333 73.1345 20 74.1878 20C74.8411 20 75.4211 19.8467 75.9278 19.54C76.4478 19.2333 76.8478 18.7867 77.1278 18.2H80.8878C80.4878 19.72 79.6945 20.92 78.5078 21.8C77.3211 22.6667 75.8945 23.1 74.2278 23.1C72.8678 23.1 71.6478 22.8 70.5678 22.2C69.5011 21.5867 68.6678 20.74 68.0678 19.66C67.4678 18.58 67.1678 17.3467 67.1678 15.96ZM93.0822 8.96V11.7H89.3622V23H85.9422V11.7H82.2222V8.96H93.0822ZM98.1586 8.96V17.36C98.1586 18.2 98.3653 18.8467 98.7786 19.3C99.1919 19.7533 99.7986 19.98 100.599 19.98C101.399 19.98 102.012 19.7533 102.439 19.3C102.865 18.8467 103.079 18.2 103.079 17.36V8.96H106.499V17.34C106.499 18.5933 106.232 19.6533 105.699 20.52C105.165 21.3867 104.445 22.04 103.539 22.48C102.645 22.92 101.645 23.14 100.539 23.14C99.4319 23.14 98.4386 22.9267 97.5586 22.5C96.6919 22.06 96.0053 21.4067 95.4986 20.54C94.9919 19.66 94.7386 18.5933 94.7386 17.34V8.96H98.1586Z",
    fill: "#0B1F51"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_261",
    x1: 0,
    y1: 0,
    x2: 25.9195,
    y2: 16.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C79E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412DA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_261",
    x1: 16.6625,
    y1: 31.4737,
    x2: 26.8452,
    y2: 13.8855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C22AEA",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.79afa9a7e240f2a0e75285df21559a68.svg";
export { ForwardRef as ReactComponent };